// extracted by mini-css-extract-plugin
export default {"bornOn":"R5n8lT3s5QHTYNtzKCrz","pulse":"L4jsHQRQSEdYFA9h2wdg"};